import {
  FormControl,
  FormHelperText,
  Switch,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { TTransportadora } from "../../@types/transportadora";
import { useForm } from "react-hook-form";
import { api } from "@/services/api";
import { UseLoading } from "@/hooks/useLoading";
import axios from "axios";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { mensagemTipo } from "../../Carregamento/services/carregamento";
import CustomHeader from "../../../../components/components/CustomHeader";
import FormDivisor from "../../components/formDivisor";
import { DownloadFileButton } from "../../Products/CriarProduto/components/downloadFileButton";
import { FiUpload } from "react-icons/fi";
import { BaseSelect } from "../../Products/CriarProduto/components/baseSelect";
import InputMask from "react-input-mask";
import { FormField } from "@/utils/FormField";
import { getFile } from "@/utils/getFile";
import ModalBase from "@/components/UI/ModalBase";
import { PlusCircleIcon } from "@phosphor-icons/react";
import { useTipoTransportadora } from "../service/useTipoTransportadora";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getTransportadoraById } from "../service/getTransportadora";
interface TransportadoraErpProps {
  isOpen: boolean;
  onClose: () => void;
}
export const TransportadoraErp = ({
  isOpen,
  onClose,
}: TransportadoraErpProps) => {
  const toast = useToast();
  const { startLoading, isLoading, stopLoading } = UseLoading();
  const { id } = useParams();
  const { isLoading: isLoader, data: transportadora } = useQuery({
    queryKey: ["transportadora", id],
    enabled: !!id,
    queryFn: async () => {
      return getTransportadoraById(id || "");
    },
  })
  const [transportadores, setTransportadores] = useState<TTransportadora[]>([]);
  let baseurl = "transportadora/geral";
  let resolver = zodResolver(
    z.object({
      bairro: z
        .string({
          required_error: mensagemTipo("Bairro", 1),
          invalid_type_error: mensagemTipo(
            "Bairro",
            3,
            "string|varchar|palavra"
          ),
        })
        .min(1, { message: mensagemTipo("Bairro", 1) }),
      cep: z
        .string({
          required_error: mensagemTipo("CEP", 3, "string|varchar|palavra"),
          invalid_type_error: mensagemTipo("CEP", 3, "string|varchar|palavra"),
        })
        .optional(),
      codcidade: z
        .number({
          invalid_type_error: mensagemTipo("Codigo Cidade", 3, "numerico"),
          required_error: mensagemTipo("Codigo Cidade", 1),
        })
        .optional(),
      codigo: z
        .string({
          invalid_type_error: mensagemTipo("Codigo Cidade", 3, "numerico"),
          required_error: mensagemTipo("Codigo Cidade", 1),
        })
        .min(1, { message: mensagemTipo("Codigo Cidade", 1) }),
      complemento: z
        .string({
          invalid_type_error: mensagemTipo("Complemento", 1),
          required_error: mensagemTipo("Complemento", 1),
        })
        .optional(),
      contato: z
        .string({
          invalid_type_error: mensagemTipo("Contato", 1),
          required_error: mensagemTipo("Contato", 1),
        })
        .optional(),
      cpfcnpj: z
        .string({
          invalid_type_error: mensagemTipo("CNPJ | CPF", 1),
          required_error: mensagemTipo("CNPJ | CPF", 1),
        })
        .min(8, { message: "Deve possuir no minímo 8" }),
      email: z.string().optional(),
      endereco: z.string().optional(),
      estado: z.string().optional(),
      ie: z
        .string({
          invalid_type_error: mensagemTipo("Nome", 1),
          required_error: mensagemTipo("Nome", 1),
        })
        .optional(),
      nome: z
        .string({
          invalid_type_error: mensagemTipo("Nome", 1),
          required_error: mensagemTipo("Nome", 1),
        })
        .min(5, { message: "Nome deve possuir no minimo de 5 caracteres." }),
      nomefantasia: z.string().optional(),
      numero: z
        .string({
          invalid_type_error: mensagemTipo("Número", 1),
          required_error: mensagemTipo("Número", 1),
        })
        .min(1, { message: mensagemTipo("Número", 1) }),
      obs: z.string().optional(),
      telefone: z
        .string({
          invalid_type_error: mensagemTipo("Telefone", 1),
          required_error: mensagemTipo("Telefone", 1),
        })
        .min(8, { message: "8 caracteres são o minímo necessário" }),
      tipo: z.number({
        invalid_type_error: mensagemTipo("Tipo", 2),
        required_error: mensagemTipo("Tipo", 1),
      }),
      ativo: z.boolean(),
    })
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm<TTransportadora>({
    resolver,
  });
  const tipoValue = watch("tipo");

  const { data: tipoOptions, isLoading: isLoadingTipo } =
    useTipoTransportadora();

  const tipoSelected =
    tipoOptions?.find((o) => o.value === String(tipoValue)) ?? null;

  const onSubmit = handleSubmit(async (values) => {
    startLoading();

    if (!values && !transportadores.length) {
      throw new Error("Nada passado!");
    }

    if (transportadores.length) {
      return await axios
        .all(
          transportadores.map((transportadora) =>
            api.post(baseurl, transportadora)
          )
        )
        .then(
          axios.spread((data) =>
            toast({
              description: "Criado com Sucesso!",
              status: "success",
            })
          )
        )
        .catch((error) =>
          toast({
            description: JSON.stringify(
              error?.response?.data?.mensagem || "Erro ao realizar operação",
              null,
              2
            ),
            status: "error",
          })
        )
        .finally(() => stopLoading());
    }

    try {
      const res = await api?.[id ? "put" : "post"](baseurl + (id ? `/${id}` : ""), values);
      const req = res.data;
      toast({
        description: `${id ? "Atualizado" : "Criado"} com Sucesso!`,
        status: "success",
      });
    } catch (error: any) {
      toast({
        description: JSON.stringify(
          error?.response?.data?.mensagem || "Erro ao realizar operação",
          null,
          2
        ),
        status: "error",
      });
    } finally {
      stopLoading();
    }
  });

  useEffect(() => {
    if (transportadora?.data) {
      const data = transportadora.data;
      reset({ ...data, numero: String(data.numero || 0), codcidade: data.codcidade || 0 });
    }
  }, [transportadora, reset]);

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      title="Cadastro Transportadora"
      size="4xl"
      icon={<PlusCircleIcon size={24} />}
      maxHeight="90vh"
    >
      <div>
        {/* <CustomHeader title="Cadastro Transportadora"></CustomHeader> */}
        <div className="flex flex-col ">
          <div className="rounded-base bg-blue-light px-[15px] py-1 text-white font-bold text-md">
            Transportadora
          </div>
          <FormDivisor title="Dados Principais" />
          <div className="flex flex-col gap-1">
            <div className="flex flex-row w-full gap-2">
              <FormField label="Código:" error={errors.codigo?.message}>
                <input
                  {...register("codigo")}
                  value={watch("codigo")}
                  placeholder="Digite o código da transportadora"
                  className={`border border-primary rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.codigo ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
              <FormField label="Tipo" error={errors.tipo?.message}>
                <BaseSelect
                  options={tipoOptions}
                  value={tipoSelected}
                  isLoading={isLoadingTipo}
                  placeholder="Selecione o tipo"
                  error={errors.tipo?.message}
                  onChange={(val) => setValue("tipo", Number(val))}
                />
              </FormField>
            </div>
            <div className="flex flex-row w-full gap-2">
              <FormField label="CPF / CNPJ:" error={errors.cpfcnpj?.message}>
                <InputMask
                  mask="99.999.999/9999-99"
                  {...register("cpfcnpj")}
                  value={watch("cpfcnpj") || ""}
                  placeholder="Digite o cpf ou cpnj"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.cpfcnpj ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
              <FormField label="IE:" error={errors.ie?.message}>
                <input
                  {...register("ie")}
                  value={watch("ie")}
                  placeholder="Digite o a IE da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.ie ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
            </div>
            <div className="flex flex-row w-full gap-2">
              <FormField label="Nome:" error={errors.nome?.message}>
                <input
                  {...register("nome")}
                  value={watch("nome")}
                  placeholder="Digite o nome da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.nome ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>{" "}
              <FormField
                label="Nome Fantasia:"
                error={errors.nomefantasia?.message}
              >
                <input
                  {...register("nomefantasia")}
                  value={watch("nomefantasia")}
                  placeholder="Digite o nome fantasia da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.nomefantasia ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
            </div>
            <FormField label="Status:" error={errors.ativo?.message}>
              <div className="flex row gap-2">
                <Switch isChecked={watch("ativo")} {...register("ativo")} />
                <label className="text-md text-primary-active font-bold">
                  Ativo
                </label>
              </div>
            </FormField>
          </div>
          <FormDivisor title="Localização da Transportadora" />
          <div className="flex flex-col gap-1">
            <div className="flex flex-row w-full gap-2">
              <FormField label="Endereço:" error={errors.endereco?.message}>
                <input
                  {...register("endereco")}
                  value={watch("endereco")}
                  placeholder="Digite o endereço da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.endereco ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
              <FormField label="Número:" error={errors.numero?.message}>
                <input
                  {...register("numero")}
                  value={watch("numero")}
                  placeholder="Digite o número da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.numero ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
            </div>
            <div className="flex flex-row w-full gap-2">
              <FormField
                label="Complemento:"
                error={errors.complemento?.message}
              >
                <input
                  {...register("complemento")}
                  value={watch("complemento")}
                  placeholder="Digite o complemento da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.complemento ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>{" "}
              <FormField label="Bairro:" error={errors.bairro?.message}>
                <input
                  {...register("bairro")}
                  value={watch("bairro")}
                  placeholder="Digite o bairro da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.bairro ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
            </div>
            <div className="flex flex-row w-full gap-2">
              <FormField
                label="Código Cidade:"
                error={errors.codcidade?.message}
              >
                <input
                  {...register("codcidade")}
                  value={watch("codcidade")}
                  placeholder="Digite o código da cidade"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.codcidade ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
              <FormField label="Estado:" error={errors.estado?.message}>
                <input
                  {...register("estado")}
                  value={watch("estado")}
                  placeholder="Digite o estado da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.estado ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
            </div>
          </div>
          <FormDivisor title="Contato" />
          <div className="flex flex-col gap-1">
            <div className="flex flex-row w-full gap-2">
              <FormField label="Email:" error={errors.email?.message}>
                <input
                  {...register("email")}
                  value={watch("email")}
                  placeholder="Digite o email da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.email ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
              <FormField label="Telefone:" error={errors.telefone?.message}>
                <input
                  {...register("telefone")}
                  value={watch("telefone")}
                  placeholder="Digite o telefone da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.telefone ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
            </div>
            <div className="flex flex-row w-full gap-2">
              <FormField
                label="Nome do Contato:"
                error={errors.contato?.message}
              >
                <input
                  {...register("contato")}
                  value={watch("contato")}
                  placeholder="Digite o nome do contato da transportadora"
                  className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.contato ? "border-red-400 focus:ring-red-400" : ""}`}
                />
              </FormField>
              <FormField label="">
                <div></div>
              </FormField>
            </div>
          </div>

          <FormDivisor title="Extras" />
          <FormField label="Observação:" error={errors.obs?.message}>
            <input
              {...register("obs")}
              value={watch("obs")}
              placeholder="Digite alguma observação"
              className={`border border-blue-light rounded-inputs w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary
                  ${errors.obs ? "border-red-400 focus:ring-red-400" : ""}`}
            />
          </FormField>
          <FormDivisor title="Importação" />
          <div className="w-full mb-2">
            <div className="relative w-full ">
              <input
                type="file"
                onChange={(event) =>
                  getFile<TTransportadora>(event, setTransportadores)
                }
                className="absolute top-0 left-0  w-full  h-full opacity-0 cursor-pointer"
              />

              <div className="flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-[#117baa]  w-full py-10 px-6 text-center hover:bg-gray-100 transition-colors">
                <FiUpload size={40} className="text-[#1f4e5f]" />
                <p className="font-semibold  w-full text-[#1f4e5f]">
                  Arraste e solte um arquivo ou clique para selecionar
                </p>
                <span className="text-sm w-full  text-gray-600">
                  Formatos suportados: CSV, XLSX, XLS
                </span>
              </div>
            </div>
          </div>
          {!id && (
            <DownloadFileButton
              fileFormater={`{
                           "ativo": "boolean",
                                          "bairro": "string",
                                          "cep": "string",
                                          "codcidade": "number",
                                          "codigo": "string",
                                          "complemento": "string",
                                          "contato": "string",
                                          "cpfcnpj": "string",
                                          "email": "string",
                                          "endereco": "string",
                                          "estado": "string",
                                          "ie": "string",
                                          "nome": "string",
                                          "nomefantasia": "string",
                                          "numero": "number",
                                          "obs": "string",
                                          "telefone": "string",
                                          "tipo": "number"
                          }`}
              title="Exemplo-Multi-Transportadoras"
            />
          )}
        </div>
        <div className="flex flex-row justify-center gap-2 mt-2">
          <button
            type="button"
            onClick={onSubmit}
            className="rounded-inputs px-6 py-2 bg-blue-base text-white font-medium hover:bg-blue-base-hover active:bg-blue-base-active"
          >
            {id ? "Atualizar" : "Cadastrar"}
          </button>

          <button
            type="button"
            className="rounded-inputs px-6 py-2 bg-red-base text-white font-medium hover:bg-red-base-hover active:bg-red-base-active"
            onClick={() =>
              reset({
                ativo: false,
                bairro: "",
                cep: "",
                codcidade: 0,
                codigo: "",
                complemento: "",
                contato: "",
                cpfcnpj: "",
                email: "",
                endereco: "",
                estado: "",
                ie: "",
                nome: "",
                nomefantasia: "",
                numero: 0,
                obs: "",
                telefone: "",
                tipo: undefined,
              })
            }
          >
            Cancelar
          </button>
        </div>
      </div>
    </ModalBase>
  );
};
